var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoerrase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_10220",
    "data-name": "Grupo 10220",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_text_icon_button",
    "data-name": "Rounded text icon button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_285",
    "data-name": "Elipse 285",
    fill: "none",
    stroke: "#fab5b4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12765",
    "data-name": "Trazado 12765",
    d: "M0,0,19,19",
    transform: "translate(4.5 4.5)",
    fill: "none",
    stroke: "#fab5b4",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon-delete",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7192",
    "data-name": "Grupo 7192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4434",
    "data-name": "Path 4434",
    d: "M46.958,33.923a.338.338,0,0,0,.34-.338V27.147a.34.34,0,0,0-.679,0v6.438a.336.336,0,0,0,.336.338h0Z",
    transform: "translate(-37.555 -21.615)",
    fill: "#fab5b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4435",
    "data-name": "Path 4435",
    d: "M34.59,33.915a.338.338,0,0,0,.338-.338v-6.44a.34.34,0,0,0-.679,0v6.44A.34.34,0,0,0,34.59,33.915Z",
    transform: "translate(-27.59 -21.607)",
    fill: "#fab5b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4436",
    "data-name": "Path 4436",
    d: "M22.21,33.7a.338.338,0,0,0,.338-.338v-6.44a.34.34,0,1,0-.679-.029v6.469A.34.34,0,0,0,22.21,33.7Z",
    transform: "translate(-17.617 -21.384)",
    fill: "#fab5b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4433",
    "data-name": "Path 4433",
    d: "M14.3,1.655H11.481V1.036A1.038,1.038,0,0,0,10.444,0H7.191A1.038,1.038,0,0,0,6.155,1.036v.618H3.337A1.079,1.079,0,0,0,2.26,2.734v.494A1.079,1.079,0,0,0,3.337,4.307H3.67v8.167A1.524,1.524,0,0,0,5.194,14h7.253a1.524,1.524,0,0,0,1.524-1.524h0V4.309H14.3A1.077,1.077,0,0,0,15.381,3.23v-.5A1.079,1.079,0,0,0,14.3,1.655ZM4.348,4.3h8.944v8.167a.848.848,0,0,1-.846.844H5.19a.846.846,0,0,1-.842-.84ZM10.8,1.034v.62H6.833v-.62A.358.358,0,0,1,7.191.677h3.253a.358.358,0,0,1,.358.358Zm-7.865,1.7a.4.4,0,0,1,.4-.4H14.3a.4.4,0,0,1,.4.4v.492a.4.4,0,0,1-.4.389H3.339a.4.4,0,0,1-.4-.389Z",
    transform: "translate(-1.821)",
    fill: "#fab5b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3142",
    "data-name": "Rect\\xE1ngulo 3142",
    width: 14,
    height: 14,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoerrase);
export default __webpack_public_path__ + "static/media/icon_noerrase.6ab4dc717450bb21af52a3cf344eda71.svg";
export { ForwardRef as ReactComponent };